import React from "react";
import { Link } from "react-router-dom";
import { LuBuilding2 } from "react-icons/lu";

import DetailSection from "./DetailSection";
import { route } from "../../static/route";
import { LinePartyProps } from "../../types/materialLine";

type Props = {
  partyId: number;
  party?: LinePartyProps | null;
};

const labelClass = "font-bold text-gray-600";

const partyPath = (id: number) =>
  route.partyDetail.replace(":id", id as unknown as string);

// The party of an order or a purchase. Like the lists, the contact name shows under the firm name, and a party without a
// firm name shows its contact name in its place.
const DetailPartyInfo = ({ partyId, party }: Props) => (
  <DetailSection title="પાર્ટી માહિતી">
    <div className="flex items-center gap-2">
      <LuBuilding2 className="h-5 w-5 shrink-0 text-[#34699A]" />
      <Link
        to={partyPath(partyId)}
        target="_blank"
        rel="noopener noreferrer"
        className="break-words text-base font-semibold hover:underline"
      >
        {party?.firm_name || party?.name || "-"}
      </Link>
    </div>

    <div className="mt-3 space-y-2 text-sm">
      <p className="break-words">
        <span className={labelClass}>સંપર્ક વ્યક્તિ:</span>{" "}
        {party?.firm_name ? party.name : ""}
      </p>
      <p>
        <span className={labelClass}>ફોન:</span> {party?.phone}
      </p>
    </div>
  </DetailSection>
);

export default DetailPartyInfo;
